import React, { useEffect, useState } from "react";
import "./Raptorize.css";
import raptorImage from "../../assets/raptor.png";

/**
 * Raptorize Component
 * Easter egg animation of a T-Rex running across the screen
 * Flies from RIGHT to LEFT and says "Projekte gefressen!"
 */
const Raptorize = ({ trigger = false, onComplete }) => {
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (trigger && !isActive) {
            setIsActive(true);

            // Duration of the animation
            setTimeout(() => {
                setIsActive(false);
                if (onComplete) {
                    onComplete();
                }
            }, 3000);
        }
    }, [trigger]);

    if (!isActive) return null;

    return (
        <div className="raptorize-container">
            <div className="raptor-wrapper">
                <img
                    src={raptorImage}
                    alt="Raptor"
                    className="raptor-image"
                />
            </div>

            {/* Custom text */}
            <div className="raptor-roar">ROAAAAR!</div>
        </div>
    );
};

export default Raptorize;
